// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"searchBox___2kcUx","searchInput":"searchInput___DYj8v"};